import { PipeTransform, Pipe } from '@angular/core';
import { FleetCardListModel } from '@app/models/customer-ccms-limits/ccmsLimitsModel';

@Pipe({
    name: 'ccmsCardlimitFilter'
})
export class CCMSCardLimitPipe implements PipeTransform {
    transform(cardlimit: FleetCardListModel[], searchTerm: string): FleetCardListModel[] {
        if (!cardlimit || !searchTerm) {
            return cardlimit;
        }
        return cardlimit.filter(ccmsCardSearch =>
            ccmsCardSearch.CardNumber.substr(12,4)
            .indexOf(searchTerm) !== -1);
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/ccmsCardLimitFilter.pipe.ts